export enum ModalState {
  Open,
  Closing,
  Closed
}
